import React,{useRef,useEffect} from "react";
import omar from "../assets/OmarPhoto.svg"
import ig from "../assets/ig.svg"
import youtube from "../assets/YouTube.svg"
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);



const Founder = ()=>{
    const founder = useRef(null);

    useEffect(() => { 
        gsap.set(founder.current, { opacity: 0, y: 100 });
        gsap.to(founder.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: founder.current,
                start: "top 95%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });
    }, []);
    

    return(
        <section className="bg-red text-white font-guton">
            <div ref={founder} className="flex flex-col w-90 mx-auto py-8 max-w-[1440px]">
                <h2 className="text-37 xl:text-64 font-semibold tracking-[-3px]">Our Founder</h2>
                <div className="flex flex-col  md:flex-row my-0">
                    <div className="w-full md:w-55 xl:w-45 md:pr-10 xl:pr-20">
                        <img src={omar} alt="omar" />
                    </div>
                    <div className="flex flex-col py-1 md:w-1/2">
                        <div className="md:flex hidden mb-2">
                            <a href="https://www.instagram.com/egpd2/"><img className="h-8 xl:h-[48px]" src={ig} alt="instagram logo" /></a>
                            <a href="https://www.youtube.com/@egypedia_"><img className="h-8 xl:h-[48px]" src={youtube} alt="Youtube logo" /></a>
                        </div>
                        <p className="text-14 mt-2 xl:text-18">CEO</p>
                        <div className="flex">
                        <h2 className="text-34 leading-30 mb-3 xl:text-60 font-semibold xl:leading-60 mb-0 xl:mb-4 tracking-[-3px]">Omar Aboelazm</h2>
                        <div className="flex block md:hidden ml-1 md:mt-[9px]">
                            <a href="https://www.youtube.com/@egypedia_"><img className="h-8 xl:h-[48px]" src={ig} alt="instagram logo" /></a>
                            <a href="https://www.instagram.com/egpd2/"><img className="h-8 xl:h-[48px]" src={youtube} alt="Youtube logo" /></a>
                        </div>
                        </div>
                        <p className="text-12 md:text-14 md:leading-14  leading-12 xl:text-22 xl:leading-26 md:tracking-[-1px] font-normal mb-4 xl:mb-6">Estudy began with Omar’s journey. After traveling to Poland to pursue his education, Omar started vlogging and documenting his experiences. He shared the challenges of settling into a new country, navigating university life, and building a future abroad.</p>
                        <p className="text-12 md:text-14 md:leading-14 leading-12 xl:text-22 xl:leading-26 md:tracking-[-1px] font-normal mb-4 xl:mb-6">Through his videos, he inspired countless students who dreamed of studying overseas but didn’t know where to start. Motivated by a passion to help others, Omar founded Estudy to provide the support and guidance he wished he had during his own journey.</p>
                        <p className="text-12 md:text-14 md:leading-14 leading-12 xl:text-22 xl:leading-26 md:tracking-[-1px] font-normal">Today, Estudy reflects Omar’s commitment to making global education accessible, ensuring every student has the tools and confidence to succeed abroad.</p>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Founder;